import { map } from 'rxjs';
import { IClientApiDependencySegment } from '@cbridge-packages/api';
import { IDictSymbolsQueryParams } from './fetchDictSymbolsRecursively';

type IDependencies = IClientApiDependencySegment;

export const fetchDictSymbols = (
  queryParams: IDictSymbolsQueryParams,
  dependencies: IDependencies,
) => {
  const { limit, skip, search } = queryParams;

  return dependencies.api.getDictSymbols({
    limit,
    skip,
    search,
  }).pipe(
    map(({ symbols }) => {
      const isLastPage = symbols.length < limit;
      const nextOffset = skip + limit;

      return {
        symbols,
        isLastPage,
        limit,
        skip: nextOffset,
        search,
      };
    }),
  );
};
